import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouteTabGroupComponent, RouterOutlet, AsyncPipe],
  selector: 'aux-qa-testing',
  templateUrl: './qa-testing.component.html',
})
export class QaTestingComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  activeTabIndex$ = new BehaviorSubject<number>(0);
  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
  tabs: TabGroupConfig[] = [
    {
      label: 'Email',
      route: ROUTING_PATH.QA_TESTING.EMAIL,
    },
  ];

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      if (params.activeTabIndex) {
        this.activeTabIndex$.next(parseInt(params.activeTabIndex, 10));
        void this.router.navigate([], { queryParams: {}, replaceUrl: true });
      }
    });
  }
}
